import { NgModule } from '@angular/core';
import { AutoCompleteOffDirective } from './auto-complete-off.directive';

@NgModule({
  declarations: [AutoCompleteOffDirective],
  exports: [AutoCompleteOffDirective],
})
export class DirectivesModule {}
